import HighlightButton, { HighlightButtonProps } from 'components/common/Buttons/HighlightButton';
import { tertiaryThemeGradient, tertiaryThemeGradientDark } from 'constants/theme';

export type OptionsMenuQuoteButtonProps = HighlightButtonProps & {
  onClick: (arg0: React.SyntheticEvent) => void;
  hidden?: boolean;
  variant?: string;
  size?: string;
};

const OptionsMenuQuoteButton = ({ firstProps, secondProps, sx, ...props }: OptionsMenuQuoteButtonProps) => (
  <HighlightButton
    variant="solid"
    size="sm"
    sx={{
      bg: tertiaryThemeGradient,
      _hover: {
        bg: tertiaryThemeGradientDark,
      },
      _disabled: {
        bg: tertiaryThemeGradientDark,
        opacity: '0.4',
        cursor: 'not-allowed',
      },
      _focus: {
        boxShadow: 'none',
      },
      color: 'primaryFontColour.400',
      borderStyle: 'solid',
      mt: 1,
      textAlign: 'center',
      ...sx,
    }}
    {...props}
  />
);

export default OptionsMenuQuoteButton;
